import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import styles from "./CollapseButton.module.scss";

export const CollapseButton = ({
    textShownOnHover,
    onClick,
    isCollapsed,
    collapseToLeft = true,
    className = styles.collapseButtonContainerLeft,
}: {
    textShownOnHover: string;
    onClick: () => void;
    isCollapsed: boolean;
    collapseToLeft?: boolean;
    className?: string;
}) => {
    const icons = collapseToLeft
        ? {
              open: IconCollection.chevronDoubleRight,
              close: IconCollection.chevronDoubleLeft,
          }
        : {
              open: IconCollection.chevronDoubleLeft,
              close: IconCollection.chevronDoubleRight,
          };

    return (
        <div className={`${styles.collapseButtonContainer} ${className}`}>
            <div className={styles.collapseButton} onClick={onClick}>
                <div className={styles.collapseButtonText}>{`${
                    isCollapsed ? "open" : "close"
                } ${textShownOnHover}`}</div>
                <Icon
                    className={styles.collapseButtonIcon}
                    icon={icons[isCollapsed ? "open" : "close"]}
                />
            </div>
        </div>
    );
};
